import { all, takeEvery, put, call } from 'redux-saga/effects'
import { getDhlDescripciones } from 'services/logisticaPedido'
import { actions } from './actions'
import { putMessage, messageType } from '../../utiles/mensaje'

export function* GET_DHL_DESCRIPCIONES() {
  try {
    const dhlDescripcionesData = yield call(getDhlDescripciones)
    if (dhlDescripcionesData.ok) {
      yield put({
        type: actions.DHL_DESCRIPCION_LOAD_SUCCEEDED,
        payload: dhlDescripcionesData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar Dhl Descripciones')
      put({
        type: actions.DHL_DESCRIPCION_LOAD_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al cargar Dhl Descripciones')
    yield all([
      put({
        type: actions.DHL_DESCRIPCION_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.DHL_DESCRIPCION_LOAD_REQUESTED, GET_DHL_DESCRIPCIONES)])
}
